import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d72dd38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preferences-section" }
const _hoisted_2 = { class: "field-container" }
const _hoisted_3 = { class: "field-container" }

import { PropType, computed } from "vue";
import { Contacts } from "acquaint-api/models/Contacts";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'marketing-preference-toggles',
  props: {
  /**
   * The contact object used with `v-model` to manage the contact information.
   * @type {Contacts}
   * @required
   */
  modelValue: {
    type: Object as PropType<Contacts>,
    required: true,
  },
  /**
   * A boolean flag to manage input element in the UI.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, typically triggered when a selection changes.
   * @event update:modelValue
   * @param {Contacts} value - The new value to be updated in the model.
   */
  "update:modelValue",
  /**
   * Emitted when the value of a field changes.
   * Notifies the parent component with the updated value and the field name.
   * @property {number} e - The updated value of the field.
   * @property {string} fieldName - The name of the field being updated.
   */
  "onValueChange",
],
  setup(__props, { emit }) {

const props = __props;





const contactData = computed({
  get: () => props.modelValue,
  set: (value: Contacts) => emit("update:modelValue", value),
});

const onValueChange = (e: number, fieldName: string) => {
  emit("onValueChange", e, fieldName);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SwitchToggle, {
        label: "Mailing List",
        labelWidth: "7.5rem",
        modelValue: contactData.value.mailingList,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactData.value.mailingList) = $event)),
        readOnly: props.readOnly,
        onOnVaueChange: _cache[1] || (_cache[1] = (e) => onValueChange(e, 'mailingList'))
      }, null, 8, ["modelValue", "readOnly"]),
      _createVNode(SwitchToggle, {
        label: "Emailing List",
        labelWidth: "7.5rem",
        modelValue: contactData.value.emailingList,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactData.value.emailingList) = $event)),
        readOnly: props.readOnly,
        onOnVaueChange: _cache[3] || (_cache[3] = (e) => onValueChange(e, 'emailingList'))
      }, null, 8, ["modelValue", "readOnly"]),
      _createVNode(SwitchToggle, {
        label: "SMS Text List",
        labelWidth: "7.5rem",
        modelValue: contactData.value.smsList,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contactData.value.smsList) = $event)),
        readOnly: props.readOnly,
        onOnVaueChange: _cache[5] || (_cache[5] = (e) => onValueChange(e, 'smsList'))
      }, null, 8, ["modelValue", "readOnly"]),
      _createVNode(SwitchToggle, {
        label: "Telephone List",
        labelWidth: "7.5rem",
        modelValue: contactData.value.telephoneList,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((contactData.value.telephoneList) = $event)),
        readOnly: props.readOnly,
        onOnVaueChange: _cache[7] || (_cache[7] = (e) => onValueChange(e, 'telephoneList'))
      }, null, 8, ["modelValue", "readOnly"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SwitchToggle, {
        label: "Pass Details to 3rd Parties",
        labelWidth: "12rem",
        modelValue: contactData.value.passDataTo3rdParties,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((contactData.value.passDataTo3rdParties) = $event)),
        readOnly: props.readOnly,
        onOnVaueChange: _cache[9] || (_cache[9] = 
          (e) => onValueChange(e, 'passDataTo3rdParties')
        )
      }, null, 8, ["modelValue", "readOnly"]),
      _createVNode(SwitchToggle, {
        label: "Pass Details to IFA",
        labelWidth: "12rem",
        modelValue: contactData.value.passDataToIFA,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((contactData.value.passDataToIFA) = $event)),
        readOnly: props.readOnly,
        onOnVaueChange: _cache[11] || (_cache[11] = (e) => onValueChange(e, 'passDataToIFA'))
      }, null, 8, ["modelValue", "readOnly"]),
      _createVNode(SwitchToggle, {
        label: "Pass Details to Conveyancer",
        labelWidth: "12rem",
        modelValue: contactData.value.passDataToConveyancer,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((contactData.value.passDataToConveyancer) = $event)),
        readOnly: props.readOnly,
        onOnVaueChange: _cache[13] || (_cache[13] = 
          (e) => onValueChange(e, 'passDataToConveyancer')
        )
      }, null, 8, ["modelValue", "readOnly"])
    ])
  ]))
}
}

})